/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BootstrapThemeColorFromJSON, BootstrapThemeColorToJSON, } from './BootstrapThemeColor';
/**
 * Check if a given object implements the TargetGroup interface.
 */
export function instanceOfTargetGroup(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    return true;
}
export function TargetGroupFromJSON(json) {
    return TargetGroupFromJSONTyped(json, false);
}
export function TargetGroupFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'color': json['color'] == null ? undefined : BootstrapThemeColorFromJSON(json['color']),
    };
}
export function TargetGroupToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'color': BootstrapThemeColorToJSON(value['color']),
    };
}
